<script setup>
import {useTimezones} from '@/composables/use-timezones.js'
import {useErrorHandling} from '@/composables/use-error-handling.js'
import {computed, toRefs, onMounted} from 'vue'

//Emits and props
const props = defineProps({
  timezone: {
    type: String,
    default: null,
  },
  emptyLabel: {
    type: String,
    default: '',
  },
  asIana: {
    type: Boolean,
    default: false,
  },
})

//Timezones and error handling
const {timezones, loadTimezones, hasLoadedTimezones} = useTimezones()
const {captureMessage} = useErrorHandling()

//Refs
const {timezone, asIana} = toRefs(props)
const isEmpty = computed(() => timezone.value === null || timezone.value === undefined || timezone.value === '')
const timezoneLabel = computed(() => {
  if (!hasLoadedTimezones.value) {
    return 'Loading...'
  }
  if (!timezone.value) {
    return ''
  }
  const tz = timezones.value.find(tz =>
    tz.value?.toLowerCase() === timezone.value.toLowerCase() ||
    tz.label?.toLowerCase() === timezone.value.toLowerCase() ||
    tz.ianaZone?.toLowerCase() === timezone.value.toLowerCase()
  )
  if (!tz) {
    captureMessage(`Unrecognised timezone: ${timezone.value}`)
    return timezone.value
  }
  return asIana.value ? tz.ianaZone : tz.label
})

//Load timezones on mount if needed
onMounted(loadTimezones)
</script>

<template>
  <span v-bind="$attrs">{{ isEmpty ? emptyLabel : timezoneLabel }}</span>
</template>
